/* eslint-disable no-unused-vars,no-unexpected-multiline */
import IM from "@/im/store/im";

function setAuthor(im, store) {
  im.$on(im.EVENTS.setAuthor, accId => {
    store.commit('im/SET_AUTHOR', accId)
  })
}
function connectLoading(im, store) {
  im.$on(im.EVENTS.connectLoading, loading => {
    store.commit('im/SET_INITLOADING', loading)
  })
}

function initSingle(im, store) {
  im.$on(im.EVENTS.initSingle, res => {
    store.dispatch('im/singleUpdate', res)
  })
}
function singleUpdate(im, store) {
  im.$on(im.EVENTS.singleUpdate, res => {
    store.dispatch('im/singleUpdate', res)
  })
}
function dismissSingle(im, store) {
  im.$on(im.EVENTS.dismissSingle, accId => {
    store.commit('im/DISMISSSINGLE', accId)
  })
}

function initTeams(im, store) {
  im.$on(im.EVENTS.initTeams, res => {
    store.dispatch('im/teamsUpdate', res)
  })
}
function teamsUpdate(im, store) {
  im.$on(im.EVENTS.teamsUpdate, team => {
    store.dispatch('im/teamsUpdate', team)
  })
}
function dismissTeam(im, store) {
  im.$on(im.EVENTS.dismissTeam, tid => {
    store.dispatch('im/dismissTeam', tid)
  })
}

function updateSession(im, store) {
  im.$on(im.EVENTS.updateSession, sessions => {
    store.commit('im/SET_SESSIONS', sessions)
  })
}

function onmsg(im, store) {
  im.$on(im.EVENTS.onmsg, msg => {
    store.dispatch('im/onmsg', msg)
  })
}
function messageUpdated(im, store) {
  im.$on(im.EVENTS.messageUpdated, msgInfo => {
    store.dispatch('im/msgUpdated', msgInfo)
  })
}
function messageLoading(im, store) {
  im.$on(im.EVENTS.messageLoading, res => {
    store.commit('im/SET_LOADINGMSG', res)
  })
}
function messageSendError(im, store) {
  im.$on(im.EVENTS.messageSendError, res => {
    store.dispatch('im/messageSendError', res)
  })
}

export default function (store) {
  const im = IM.initIMClientInstance();
  setAuthor(im, store)
  connectLoading(im, store)

  initSingle(im, store)
  singleUpdate(im, store)
  dismissSingle(im, store)
  
  initTeams(im, store)
  teamsUpdate(im, store)
  dismissTeam(im, store)

  updateSession(im, store)

  onmsg(im, store)
  messageUpdated(im, store)
  messageLoading(im, store)
  messageSendError(im, store)

  window.im = im;
}
